import { render, staticRenderFns } from "./OrganizationRebate.vue?vue&type=template&id=45a3a65c&scoped=true&"
import script from "./OrganizationRebate.vue?vue&type=script&lang=js&"
export * from "./OrganizationRebate.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationRebate.vue?vue&type=style&index=0&id=45a3a65c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3a65c",
  null
  
)

export default component.exports